import React, { useState ,useEffect} from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { Form, Button ,Row,Col,Image,Container,Modal,Text} from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import jimp from "jimp";
import imageCompression from "browser-image-compression";
import { replyOnTicket } from "../../pages/ticket-list/ticketsAction";

export const UpdateTicket = ({ _id }) => {
  const dispatch = useDispatch();
  const {
    user: { name },
  } = useSelector((state) => state.user);
  const [message, setMessage] = useState("");
  const [file, setfile] = useState('');
  const [show, setShow] = useState(false);
  const [image, setImage] = useState([]);
  const [blob, setBlob] = useState("");
  const handleOnChange =async (e) => {
      setMessage(e.target.value);
  };

  useEffect(() => {
    const result =  axios.get(
          `https://repairs.incosa.io/v1/image/${_id}`,
          {},
          {
            headers: {
              Authorization: sessionStorage.getItem("accessJWT"),
            },
          }
        ).then((res)=>{setImage(res.data.data)
          console.log(res.data);
          
        }
        );
  }, [])
  


  const handleOnImageChange =async (e) => {
       if (e.target.files && e.target.files[0]) {
         const files = e.target.files[0];
         const options = {
           maxSizeMB: 0.450,
           maxWidthOrHeight: 1920,
           useWebWorker: true,
         };
         try {
           const compressedFile = await imageCompression(files, options);
           console.log(
             "compressedFile instanceof Blob",
             compressedFile instanceof Blob
           ); // true
           console.log(
             `compressedFile size ${compressedFile.size / 1024 / 1024} MB`
           ); // smaller than maxSizeMB
            let reader = new FileReader();
            reader.onloadend = () => {
              setfile(compressedFile);
            };
            reader.readAsDataURL(compressedFile);
         } catch (error) {
           console.log(error);
         }
         //const url = URL.createObjectURL(file);
       // setBlob(url);
        
        //console.log(file);
       };
       }

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const msgObj = {
      message,
      sender: name,
    };
    dispatch(replyOnTicket(_id, msgObj));
    setMessage("");
  };
  toast.configure();
  function toastLogin() {
    toast("Image Successfully uploaded!", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  }
  const handleOnImageSubmit = async (e) => {
    if (file!='') {
          const convertToBase64 = (file) => {
            return new Promise((resolve, reject) => {
              const fileReader = new FileReader();
              fileReader.readAsDataURL(file);
              fileReader.onload = () => {
                resolve(fileReader.result);
              };
              fileReader.onerror = (error) => {
                reject(error);
              };
            });
          };
          
          e.preventDefault();
          //console.log(file.name);
          const base64 = await convertToBase64(file);
          //console.log(newBase64);
          var bindata = base64.split(",")[1];
          console.log(bindata);
          const formData = new FormData();

          formData.append("file", bindata);
          formData.append("blob", blob);
          formData.append("name", file.name);
          formData.append("ticketId", _id);
          formData.append("addedBy", name);
          try {
            const result = await axios.post(
              `https://repairs.incosa.io/v1/image/upload`,
              formData,
              {
                headers: {
                  Authorization: sessionStorage.getItem("accessJWT"),
                },
              }
            );
            console.log(result);
            if (result.data.status === 200) {
              toastLogin();
              setTimeout(() => {
              window.location.reload();
              }, 2001)
              
              
            }
          } catch (err) {
            console.log(err);
          }
        }
          //setfile('')
        };;
  const handleClose = () => {
    setShow(false);
  };

  function openImageTab(Url,title){
    window.open(Url, title, "width=800, height=600");
    return false;
  }


  return (
    <div>
      <Form onSubmit={handleOnSubmit}>
        <Form.Label>Reply</Form.Label>
        <Form.Text>
          Please reply your message here or update the ticket
        </Form.Text>
        <Form.Control
          value={message}
          onChange={handleOnChange}
          as="textarea"
          row="5"
          name="detail"
        />

        <div className="text-right mt-3 mb-3">
          <Button variant="dark" type="submit">
            Reply
          </Button>
        </div>
        <Button onClick={() => setShow(true)}>Images</Button>
      </Form>

      <div>
        <Modal
          contentClassName="transparentBgClass"
          show={show}
          size="xl"
          onHide={handleClose}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Analyse and Upload Images</Modal.Title>
          </Modal.Header>
          <Container className="container"  >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                padding: "2%",
               
              }}
            >
              {image &&
                image.map((singleImage) => {
                  const base64 = Buffer.from(
                    singleImage.image.data.data,
                    "binary"
                  ).toString("base64");
                  const title = singleImage.name.substring(
                    0,
                    singleImage.name.lastIndexOf(".")
                  );
                  return (
                    // <Col className="md">
                    <div
                      style={{
                        paddingLeft: "2.5%",
                        paddingRight: "2.5%",
                        paddingBottom: "4%",
                        // maxHeight: "200px"
                      }}
                    >
                      <div>
                        <Image
                          className="img-fluid"
                          rounded="true"
                          style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                            border: "1px solid",
                          }}
                          src={`data:image/png;base64,${base64}`}
                          alt="logo"
                        
                        />
                      </div>
                      <div
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          height: "30px",
                        }}
                      >
                        {title}
                      </div>
                    </div>
                    // </Col>
                  );
                })}
            </div>
            {/* <Row > */}

            {/* </Row>{" "} */}

            <Modal.Footer>
              <Row>
                <Form onSubmit={handleOnImageSubmit}>
                  <Form.Group
                    controlId="formFile"
                    className="mb-3"
                    style={{ paddingLeft: "5%" }}
                  >
                    <Form.Label>Upload a new Image</Form.Label>
                    <Form.Control
                      accept=".jpg, .png|image/*"
                      onChange={handleOnImageChange}
                      type="file"
                      name="image"
                    />

                    <div className="text-right mt-3 mb-3">
                      <Button type="submit">Upload Image</Button>
                    </div>
                  </Form.Group>
                </Form>
              </Row>
            </Modal.Footer>
          </Container>
        </Modal>
      </div>
    </div>
  );
};

UpdateTicket.propTypes = {
  _id: PropTypes.string.isRequired,
};
